module.exports = __webpack_public_path__ + "img/circleBack.80fc3147.svg";